<script lang="ts">
	import { classes } from '$lib/utils';
	export let additionalClass = '';
</script>

<svg
	width="100%"
	height="100%"
	viewBox="0 0 513 1134"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
	class={classes('', additionalClass)}
>
	<g style="mix-blend-mode:multiply" filter="url(#filter0_f_8118_60903)">
		<path
			d="M546.89 905.066C730.406 886.327 865.418 736.4 848.447 570.194C831.476 403.988 763.113 232.45 490.758 236.782C307.241 255.52 159.048 394.918 332.955 580.454C475.999 733.063 363.373 923.805 546.89 905.066Z"
			fill="url(#paint0_linear_8118_60903)"
		/>
	</g>
	<defs>
		<filter
			id="filter0_f_8118_60903"
			x="95.5293"
			y="76.7012"
			width="914.357"
			height="989.646"
			filterUnits="userSpaceOnUse"
			color-interpolation-filters="sRGB"
		>
			<feFlood flood-opacity="0" result="BackgroundImageFix" />
			<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
			<feGaussianBlur stdDeviation="80" result="effect1_foregroundBlur_8118_60903" />
		</filter>
		<linearGradient
			id="paint0_linear_8118_60903"
			x1="428.873"
			y1="265.358"
			x2="598.163"
			y2="907.79"
			gradientUnits="userSpaceOnUse"
		>
			<stop stop-color="#F7FBA5" />
			<stop offset="0.541667" stop-color="#D09CC7" />
			<stop offset="1" stop-color="#8F00FF" />
		</linearGradient>
	</defs>
</svg>
